import { useEffect } from "react";

/** Sets the browser tab title to "<title> | OneCheckUp" (or just the app name while title is empty). */
export function usePageTitle(title?: string | null) {
    useEffect(() => {
        document.title = title ? `${title} | OneCheckUp` : "OneCheckUp";
    }, [title]);
}
